import React from 'react';

const RDV_TYPE = {
  MEDECIN: { label: 'Médecin', tone: 'primary' },
  DENTISTE: { label: 'Dentiste', tone: 'success' },
  INFIRMERIE: { label: 'Infirmerie', tone: 'info' },
  AUTRE_SERVICE: { label: 'Autre', tone: 'neutral' }
};

const RDV_STATUS = {
  EN_ATTENTE: { label: 'En attente', tone: 'warning' },
  CONFIRME: { label: 'Confirmé', tone: 'success' },
  TERMINE: { label: 'Terminé', tone: 'neutral' },
  ANNULE: { label: 'Annulé', tone: 'danger' },
  ABSENT: { label: 'Absent', tone: 'danger' }
};

const VISIT_STATUS = {
  REGISTERED: { label: 'À orienter', tone: 'warning' },
  ORIENTED: { label: 'Orienté', tone: 'success' }
};

const PRIORITY = {
  URGENT: { label: 'Urgent', tone: 'danger' },
  NORMALE: { label: 'Normale', tone: 'neutral' }
};

const CONSULT_STATUS = {
  PENDING: { label: 'En attente', tone: 'warning' },
  COMPLETED: { label: 'Terminée', tone: 'success' },
  CANCELLED: { label: 'Annulée', tone: 'danger' }
};

const MAPS = {
  rdvType: RDV_TYPE,
  rdvStatus: RDV_STATUS,
  visit: VISIT_STATUS,
  priority: PRIORITY,
  consultation: CONSULT_STATUS
};

export default function ReceptionStatusBadge({ kind, value, className = '' }) {
  const map = MAPS[kind] || {};
  const entry = map[value] || { label: value || '—', tone: 'neutral' };
  return (
    <span className={`recv-status recv-status--${entry.tone} ${className}`.trim()}>{entry.label}</span>
  );
}
